import { useState } from "react";
import { queryType } from "../firestore/basicOperations";
import getDocsList from "../firestore/getDocsList";

const useGetTopics = () => {
  const [topicsList, setTopicsList] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getTopicsList = async (queries: queryType) => {
    try {
      console.log(queries);
      setLoading(true);
      const data = await getDocsList("topics", queries);
      setTopicsList(data);
    } catch (error) {
      // if(error.response.status === 401){
      //   setChaptersList(error.response.data)
      // }
      console.log("Error fetching chapters");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return { getTopicsList, topicsList, loading };
};

export default useGetTopics;
